<template>
  <div>
    <NavBar />
    <slot />

<footer class="footer">
    <div class="container">
      <div class="columns is-centered">
        <div class="column">
          <div class="content has-text-left">
            <p>
              Made by
              <a href="https://microappsdev.com">Jens @ MicroAppsDev</a>
            </p>

            <p>
              <strong>Questions?</strong> <br />Email me at
              hello@feedletter.co
            </p>
            <p>Version: {{ appVersion }}</p>
          </div>
        </div>
        <div class="column">
          <div class="content has-text-right">
            <p>
              Features:
              <br />
              <a href="/#howitworks">Newsletter Survey</a><br />
              <a href="/feedback-widget">Feedback Widgets</a><br />

              <br />Compare:
              <br />
              <a href="/feedletter-vs-sparkloop-reactions/">Sparkloop Reactions</a><br />
              </p>
          </div>
        </div>
        <div class="column">
          <div class="content has-text-right">
            <p>
              Resources:
              <br />
              <a href="/help/">Help Pages</a><br />
              <a href="/blog">Blog</a><br />
              <a href="/casestudies/">Case Studies</a><br />
              <a href="/feedback-button/">Feedback Button Guide</a><br />
              <a href="/changelog">Product Updates</a><br />
              <a href="/faq">FAQ</a>
              </p>
          </div>
        </div>
        <div class="column is-3 content has-text-right">
          <p>
            Legal:
          <br />

          <a href="https://microappsdev.com/imprint">Imprint</a>

          <br />

          <a href="https://microappsdev.com/privacy">Privacy</a>

          </p>
        </div>
      </div>
    </div>
  </footer>
    
  </div>
</template>
<script>
// @ is an alias to /src
import NavBar from "@/components/NavBar.vue";
import ConfirmationForm from "@/components/ConfirmationForm.vue";
import RecoveryForm from "@/components/RecoveryForm.vue";
import { mapState } from 'vuex'

export default {
  name: "AppLayoutDefault",
  components: {
    NavBar,
    RecoveryForm,
  },
  data: function () {
    return {
      appVersion: process.env.APP_VERSION,
      confirmationToken: null,
      recoveryToken: null,

    };
  },

  mounted: function () {
    if (window.location.hash) {
      var hash = window.location.hash.substring(1);
      if (hash.startsWith("confirmation_token=")) {
        this.confirmationToken = hash.replace("confirmation_token=", "");
        this.trackPageView("confirmed")
      }
      if (hash.startsWith("recovery_token=")) {
        this.recoveryToken = hash.replace("recovery_token=", "");
        this.$emit("attempt-recovery");
      }
      
    }

    if (this.confirmationToken) {
      this.$buefy.modal.open({
        parent: this,
        component: ConfirmationForm,
        hasModalCard: false,
        canCancel: false,
        width: 640,
        trapFocus: true,
        props: {confirmationToken: this.confirmationToken}
      })
    }

    if (this.recoveryToken) {
      this.$buefy.modal.open({
        parent: this,
        component: RecoveryForm,
        hasModalCard: false,
        canCancel: false,
        width: 640,
        trapFocus: true,
        props: {recoveryToken: this.recoveryToken}
      })
    }
  },
  computed: {
    ...mapState([
      "user",
    ])
  },
  methods: {

  },
};
</script>